import IOS from './IOS'

export default IOS
// eslint-disable-next-line import/export
export * from './IOS'
